import { render, staticRenderFns } from "./detalleInformacion.vue?vue&type=template&id=3c5beb29&scoped=true&"
import script from "./detalleInformacion.vue?vue&type=script&lang=js&"
export * from "./detalleInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5beb29",
  null
  
)

export default component.exports